// extracted by mini-css-extract-plugin
module.exports = {"flex":"DisplayBanner_flex__14eij","message":"DisplayBanner_message__2ZRpW"};